<template>
  <div style="height: 100%">
    <div class="row" v-if="!loading">
      <template v-if="country === 'br'">
        <div id="panel-template" class="panel-template" :class="panelLeft">
          <div class="template-header">
            <img :src="logo" />
          </div>

          <div
            class="template-body"
            v-html="emailTemplateCustom.htmlBodyPt"
          ></div>

          <!-- pergunta acima da metrica -->
          <div class="template-question" v-html="action.questionHTML"></div>

          <div class="template-methodology">
            <methodology
              :lang="country"
              :templateColor="
                templateSelected ? templateSelected.scale : templateSelected
              "
              :actionMetric="action.type"
            />
          </div>

          <div
            class="template-body"
            v-html="emailTemplateCustom.customHtmlFooterPt"
          ></div>

          <!-- rodape logo -->
          <!-- <div
          class="template-footer"
          v-if="action.email.template.footer && action.channel !== 'widget'"
        >
          <img src="../../../../assets/logo-indecx.png" />
        </div> -->
        </div>
        <div id="config-template2" class="config-template" :class="panelRight">
          <div id="btn-actions" class="btn-actions">
            <button class="btn btn-primary" @click="expandPanel">
              <font-awesome-icon :icon="['fas', 'pen']" />
            </button>
            <button
              v-if="showReturn"
              :title="`${this.$t('newAction.buttonReturn')}`"
              class="btn btn-primary"
              @click="returnPanel"
            >
              <i class="fas fa-arrow-left"></i>
            </button>
            <modal-test-survey-email-custom
              class="mt-2"
              :isTemplateEmailCustom="true"
              v-if="action.channel !== 'widget' && action.channel !== 'qrcode'"
            />
          </div>
          <transition name="fade">
            <!-- //configurações -->
            <!-- //menu lateral -->
            <div v-if="panelOptions">
              <!-- //multi idioma -->
              <div v-if="action.enableTranslation">
                <p>
                  Selecione o idioma do template configurado e clique em salvar
                </p>

                <b-dropdown id="select-language">
                  <template slot="button-content">
                    <country-flag :country="country" size="normal" />
                    {{ countryName }}
                  </template>

                  <b-dropdown-item @click="selectCountry('Português')">
                    <country-flag country="br" size="normal" />
                    {{ this.$t('dashboard.portugues') }}
                  </b-dropdown-item>

                  <b-dropdown-item @click="selectCountry('English')">
                    <country-flag country="us" size="normal" />
                    {{ this.$t('dashboard.ingles') }}
                  </b-dropdown-item>

                  <b-dropdown-item @click="selectCountry('Español')">
                    <country-flag country="es" size="normal" />
                    {{ this.$t('dashboard.espanhol') }}
                  </b-dropdown-item>
                </b-dropdown>

                <button
                  @click="saveTemplateTranslation(countryName)"
                  style="border: none; background: #fff"
                >
                  <i class="fas fa-save"></i>
                </button>

                <p>Templates traduzidos salvos</p>

                <div class="tag" v-if="emailTemplateCustom.enableTemplatePt">
                  <span> Tradução: Português </span>
                  <span @click="removeTemplate('pt')" class="remove">
                    &times;
                  </span>
                </div>

                <div class="tag" v-if="emailTemplateCustom.enableTemplateEn">
                  <span> Tradução: Inglês </span>
                  <span @click="removeTemplate('en')" class="remove">
                    &times;
                  </span>
                </div>

                <div class="tag" v-if="emailTemplateCustom.enableTemplateEs">
                  <span> Tradução: Espanhol </span>
                  <span @click="removeTemplate('es')" class="remove">
                    &times;
                  </span>
                </div>
              </div>

              <!-- //upload -->
              <div class="row">
                <div class="col-12">
                  <input
                    type="text"
                    class="form-control input-panel"
                    :value="`Cabeçalho`"
                    disabled
                  />

                  <div class="row custom-switch" style="padding-left: 35px">
                    <div class="col-12">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="logo-header-custom"
                        v-model="
                          action.email.template.emailTemplateCustom
                            .enableHeaderLogo
                        "
                      />
                      <label
                        class="custom-control-label"
                        for="logo-header-custom"
                        >{{ $t('newAction.stepOne.labels.able') }}</label
                      >
                    </div>
                  </div>
                  <b-form-group class="mt-2">
                    <b-form-file
                      @change="selectUploadFile($event.target.files)"
                      browse-text="upload"
                      id="file-small"
                      size="sm"
                    ></b-form-file>
                  </b-form-group>
                </div>
              </div>

              <!-- corpo do email -->
              <div class="row mb-2">
                <div class="col-12">
                  <input
                    type="text"
                    class="form-control input-panel"
                    :value="`Texto de introdução`"
                    disabled
                  />

                  <div class="row custom-switch" style="padding-left: 35px">
                    <div class="col-12">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="body-custom"
                        v-model="
                          action.email.template.emailTemplateCustom.enableBody
                        "
                      />
                      <label class="custom-control-label" for="body-custom">{{
                        $t('newAction.stepOne.labels.able')
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <wysiwyg
                api-key="no-api-key"
                license_key="gpl2"
                tinymceScriptSrc="https://tinymce5.s3.amazonaws.com/tinymce/tinymce.min.js"
                :init="{
                  selector: 'wysiwyg',
                  menubar: false,
                  statusbar: false,
                  language: this.$t('newAction.stepOne.editorLanguage'),
                  plugins: 'link image lists hr emoticons',
                  toolbar:
                    'bold italic underline | alignleft aligncenter alignright alignjustify | link image | code | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight |',
                  lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                  fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
                  font_formats:
                    'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                  image_description: false,
                  image_title: false,
                  content_style:
                    'img {max-width: 100%; max-height: 100%}, @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
                  image_dimensions: false,
                  file_picker_types: 'image',
                  images_upload_handler: imagesUploadHandlerFooter,
                  file_picker_callback: function (cb, value, meta) {
                    uploadImgTinyMce(cb);
                  },
                }"
                v-if="panelLeft === 'col-8'"
                v-model="emailTemplateCustom.htmlBodyPt"
              />

              <!-- rodapé do email -->
              <div class="row mb-2">
                <div class="col-12">
                  <input
                    type="text"
                    class="form-control input-panel"
                    :value="`Rodapé`"
                    disabled
                  />

                  <div class="row custom-switch" style="padding-left: 35px">
                    <div class="col-12">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="footer-custom"
                        v-model="
                          action.email.template.emailTemplateCustom.enableFooter
                        "
                      />
                      <label class="custom-control-label" for="footer-custom">{{
                        $t('newAction.stepOne.labels.able')
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <wysiwyg
                api-key="no-api-key"
                license_key="gpl2"
                tinymceScriptSrc="https://tinymce5.s3.amazonaws.com/tinymce/tinymce.min.js"
                :init="{
                  selector: 'wysiwyg',
                  menubar: false,
                  statusbar: false,
                  language: this.$t('newAction.stepOne.editorLanguage'),
                  plugins: 'link image lists hr emoticons',
                  toolbar:
                    'bold italic underline | alignleft aligncenter alignright alignjustify | link image | code | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight |',
                  lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                  fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
                  font_formats:
                    'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                  image_description: false,
                  image_title: false,
                  content_style:
                    'img {max-width: 100%; max-height: 100%}, @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
                  image_dimensions: false,
                  file_picker_types: 'image',
                  images_upload_handler: imagesUploadHandlerFooter,
                  file_picker_callback: function (cb, value, meta) {
                    uploadImgTinyMce(cb);
                  },
                }"
                v-if="panelLeft === 'col-8'"
                v-model="emailTemplateCustom.customHtmlFooterPt"
              />
            </div>
          </transition>
        </div>
      </template>

      <template v-if="country === 'us'">
        <div id="panel-template" class="panel-template" :class="panelLeft">
          <div class="template-header">
            <img :src="logo" />
          </div>

          <div
            class="template-body"
            v-html="emailTemplateCustom.htmlBodyEn"
          ></div>

          <!-- pergunta acima da metrica -->
          <div class="template-question" v-html="action.questionHTML"></div>

          <div class="template-methodology">
            <methodology
              :lang="country"
              :templateColor="
                templateSelected ? templateSelected.scale : templateSelected
              "
              :actionMetric="action.type"
            />
          </div>

          <div
            class="template-body"
            v-html="emailTemplateCustom.customHtmlFooterEn"
          ></div>

          <!-- rodape logo -->
          <!-- <div
          class="template-footer"
          v-if="action.email.template.footer && action.channel !== 'widget'"
        >
          <img src="../../../../assets/logo-indecx.png" />
        </div> -->
        </div>
        <div id="config-template2" class="config-template" :class="panelRight">
          <div id="btn-actions" class="btn-actions">
            <button class="btn btn-primary" @click="expandPanel">
              <font-awesome-icon :icon="['fas', 'pen']" />
            </button>
            <button
              v-if="showReturn"
              :title="`${this.$t('newAction.buttonReturn')}`"
              class="btn btn-primary"
              @click="returnPanel"
            >
              <i class="fas fa-arrow-left"></i>
            </button>
            <modal-test-survey-email-custom
              class="mt-2"
              :isTemplateEmailCustom="true"
              v-if="action.channel !== 'widget' && action.channel !== 'qrcode'"
            />
          </div>
          <transition name="fade">
            <!-- //configurações -->
            <!-- //menu lateral -->
            <div v-if="panelOptions">
              <!-- //multi idioma -->
              <div v-if="action.enableTranslation">
                <p>
                  Selecione o idioma do template configurado e clique em salvar
                </p>

                <b-dropdown id="select-language">
                  <template slot="button-content">
                    <country-flag :country="country" size="normal" />
                    {{ countryName }}
                  </template>

                  <b-dropdown-item @click="selectCountry('Português')">
                    <country-flag country="br" size="normal" />
                    {{ this.$t('dashboard.portugues') }}
                  </b-dropdown-item>

                  <b-dropdown-item @click="selectCountry('English')">
                    <country-flag country="us" size="normal" />
                    {{ this.$t('dashboard.ingles') }}
                  </b-dropdown-item>

                  <b-dropdown-item @click="selectCountry('Español')">
                    <country-flag country="es" size="normal" />
                    {{ this.$t('dashboard.espanhol') }}
                  </b-dropdown-item>
                </b-dropdown>

                <button
                  @click="saveTemplateTranslation(countryName)"
                  style="border: none; background: #fff"
                >
                  <i class="fas fa-save"></i>
                </button>

                <p>Templates traduzidos salvos</p>

                <div class="tag" v-if="emailTemplateCustom.enableTemplatePt">
                  <span> Tradução: Português </span>
                  <span @click="removeTemplate('pt')" class="remove">
                    &times;
                  </span>
                </div>

                <div class="tag" v-if="emailTemplateCustom.enableTemplateEn">
                  <span> Tradução: Inglês </span>
                  <span @click="removeTemplate('en')" class="remove">
                    &times;
                  </span>
                </div>

                <div class="tag" v-if="emailTemplateCustom.enableTemplateEs">
                  <span> Tradução: Espanhol </span>
                  <span @click="removeTemplate('es')" class="remove">
                    &times;
                  </span>
                </div>
              </div>

              <!-- //upload -->
              <div class="row">
                <div class="col-12">
                  <input
                    type="text"
                    class="form-control input-panel"
                    :value="`Cabeçalho`"
                    disabled
                  />

                  <div class="row custom-switch" style="padding-left: 35px">
                    <div class="col-12">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="logo-header-custom"
                        v-model="
                          action.email.template.emailTemplateCustom
                            .enableHeaderLogo
                        "
                      />
                      <label
                        class="custom-control-label"
                        for="logo-header-custom"
                        >{{ $t('newAction.stepOne.labels.able') }}</label
                      >
                    </div>
                  </div>
                  <b-form-group class="mt-2">
                    <b-form-file
                      @change="selectUploadFile($event.target.files)"
                      browse-text="upload"
                      id="file-small"
                      size="sm"
                    ></b-form-file>
                  </b-form-group>
                </div>
              </div>

              <!-- corpo do email -->
              <div class="row mb-2">
                <div class="col-12">
                  <input
                    type="text"
                    class="form-control input-panel"
                    :value="`Texto de introdução`"
                    disabled
                  />

                  <div class="row custom-switch" style="padding-left: 35px">
                    <div class="col-12">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="body-custom"
                        v-model="
                          action.email.template.emailTemplateCustom.enableBody
                        "
                      />
                      <label class="custom-control-label" for="body-custom">{{
                        $t('newAction.stepOne.labels.able')
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <wysiwyg
                api-key="no-api-key"
                license_key="gpl2"
                tinymceScriptSrc="https://tinymce5.s3.amazonaws.com/tinymce/tinymce.min.js"  
                :init="{
                  selector: 'wysiwyg',
                  menubar: false,
                  statusbar: false,
                  language: this.$t('newAction.stepOne.editorLanguage'),
                  plugins: 'link image lists hr emoticons',
                  toolbar:
                    'bold italic underline | alignleft aligncenter alignright alignjustify | link image | code | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight |',
                  lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                  fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
                  font_formats:
                    'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                  image_description: false,
                  image_title: false,
                  content_style:
                    'img {max-width: 100%; max-height: 100%}, @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
                  image_dimensions: false,
                  file_picker_types: 'image',
                  images_upload_handler: imagesUploadHandlerFooter,
                  file_picker_callback: function (cb, value, meta) {
                    uploadImgTinyMce(cb);
                  },
                }"
                v-if="panelLeft === 'col-8'"
                v-model="emailTemplateCustom.htmlBodyEn"
              />

              <!-- rodapé do email -->
              <div class="row mb-2">
                <div class="col-12">
                  <input
                    type="text"
                    class="form-control input-panel"
                    :value="`Rodapé`"
                    disabled
                  />

                  <div class="row custom-switch" style="padding-left: 35px">
                    <div class="col-12">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="footer-custom"
                        v-model="
                          action.email.template.emailTemplateCustom.enableFooter
                        "
                      />
                      <label class="custom-control-label" for="footer-custom">{{
                        $t('newAction.stepOne.labels.able')
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <wysiwyg
                api-key="no-api-key"
                license_key="gpl2"
                tinymceScriptSrc="https://tinymce5.s3.amazonaws.com/tinymce/tinymce.min.js"
                :init="{
                  selector: 'wysiwyg',
                  menubar: false,
                  statusbar: false,
                  language: this.$t('newAction.stepOne.editorLanguage'),
                  plugins: 'link image lists hr emoticons',
                  toolbar:
                    'bold italic underline | alignleft aligncenter alignright alignjustify | link image | code | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight |',
                  lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                  fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
                  font_formats:
                    'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                  image_description: false,
                  image_title: false,
                  content_style:
                    'img {max-width: 100%; max-height: 100%}, @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
                  image_dimensions: false,
                  file_picker_types: 'image',
                  images_upload_handler: imagesUploadHandlerFooter,
                  file_picker_callback: function (cb, value, meta) {
                    uploadImgTinyMce(cb);
                  },
                }"
                v-if="panelLeft === 'col-8'"
                v-model="emailTemplateCustom.customHtmlFooterEn"
              />
            </div>
          </transition>
        </div>
      </template>

      <template v-if="country === 'es'">
        <div id="panel-template" class="panel-template" :class="panelLeft">
          <div class="template-header">
            <img :src="logo" />
          </div>

          <div
            class="template-body"
            v-html="emailTemplateCustom.htmlBodyEs"
          ></div>

          <!-- pergunta acima da metrica -->
          <div class="template-question" v-html="action.questionHTML"></div>

          <div class="template-methodology">
            <methodology
              :lang="country"
              :templateColor="
                templateSelected ? templateSelected.scale : templateSelected
              "
              :actionMetric="action.type"
            />
          </div>

          <div
            class="template-body"
            v-html="emailTemplateCustom.customHtmlFooterEs"
          ></div>

          <!-- rodape logo -->
          <!-- <div
          class="template-footer"
          v-if="action.email.template.footer && action.channel !== 'widget'"
        >
          <img src="../../../../assets/logo-indecx.png" />
        </div> -->
        </div>
        <div id="config-template2" class="config-template" :class="panelRight">
          <div id="btn-actions" class="btn-actions">
            <button class="btn btn-primary" @click="expandPanel">
              <font-awesome-icon :icon="['fas', 'pen']" />
            </button>
            <button
              v-if="showReturn"
              :title="`${this.$t('newAction.buttonReturn')}`"
              class="btn btn-primary"
              @click="returnPanel"
            >
              <i class="fas fa-arrow-left"></i>
            </button>
            <modal-test-survey-email-custom
              class="mt-2"
              :isTemplateEmailCustom="true"
              v-if="action.channel !== 'widget' && action.channel !== 'qrcode'"
            />
          </div>
          <transition name="fade">
            <!-- //configurações -->
            <!-- //menu lateral -->
            <div v-if="panelOptions">
              <!-- //multi idioma -->
              <div v-if="action.enableTranslation">
                <p>
                  Selecione o idioma do template configurado e clique em salvar
                </p>

                <b-dropdown id="select-language">
                  <template slot="button-content">
                    <country-flag :country="country" size="normal" />
                    {{ countryName }}
                  </template>

                  <b-dropdown-item @click="selectCountry('Português')">
                    <country-flag country="br" size="normal" />
                    {{ this.$t('dashboard.portugues') }}
                  </b-dropdown-item>

                  <b-dropdown-item @click="selectCountry('English')">
                    <country-flag country="us" size="normal" />
                    {{ this.$t('dashboard.ingles') }}
                  </b-dropdown-item>

                  <b-dropdown-item @click="selectCountry('Español')">
                    <country-flag country="es" size="normal" />
                    {{ this.$t('dashboard.espanhol') }}
                  </b-dropdown-item>
                </b-dropdown>

                <button
                  @click="saveTemplateTranslation(countryName)"
                  style="border: none; background: #fff"
                >
                  <i class="fas fa-save"></i>
                </button>

                <p>Templates traduzidos salvos</p>

                <div class="tag" v-if="emailTemplateCustom.enableTemplatePt">
                  <span> Tradução: Português </span>
                  <span @click="removeTemplate('pt')" class="remove">
                    &times;
                  </span>
                </div>

                <div class="tag" v-if="emailTemplateCustom.enableTemplateEn">
                  <span> Tradução: Inglês </span>
                  <span @click="removeTemplate('en')" class="remove">
                    &times;
                  </span>
                </div>

                <div class="tag" v-if="emailTemplateCustom.enableTemplateEs">
                  <span> Tradução: Espanhol </span>
                  <span @click="removeTemplate('es')" class="remove">
                    &times;
                  </span>
                </div>
              </div>

              <!-- //upload -->
              <div class="row">
                <div class="col-12">
                  <input
                    type="text"
                    class="form-control input-panel"
                    :value="`Cabeçalho`"
                    disabled
                  />

                  <div class="row custom-switch" style="padding-left: 35px">
                    <div class="col-12">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="logo-header-custom"
                        v-model="
                          action.email.template.emailTemplateCustom
                            .enableHeaderLogo
                        "
                      />
                      <label
                        class="custom-control-label"
                        for="logo-header-custom"
                        >{{ $t('newAction.stepOne.labels.able') }}</label
                      >
                    </div>
                  </div>
                  <b-form-group class="mt-2">
                    <b-form-file
                      @change="selectUploadFile($event.target.files)"
                      browse-text="upload"
                      id="file-small"
                      size="sm"
                    ></b-form-file>
                  </b-form-group>
                </div>
              </div>

              <!-- corpo do email -->
              <div class="row mb-2">
                <div class="col-12">
                  <input
                    type="text"
                    class="form-control input-panel"
                    :value="`Texto de introdução`"
                    disabled
                  />

                  <div class="row custom-switch" style="padding-left: 35px">
                    <div class="col-12">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="body-custom"
                        v-model="
                          action.email.template.emailTemplateCustom.enableBody
                        "
                      />
                      <label class="custom-control-label" for="body-custom">{{
                        $t('newAction.stepOne.labels.able')
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <wysiwyg
                api-key="no-api-key"
                license_key="gpl2"
                tinymceScriptSrc="https://tinymce5.s3.amazonaws.com/tinymce/tinymce.min.js"
                :init="{
                  selector: 'wysiwyg',
                  menubar: false,
                  statusbar: false,
                  language: this.$t('newAction.stepOne.editorLanguage'),
                  plugins: 'link image lists hr emoticons',
                  toolbar:
                    'bold italic underline | alignleft aligncenter alignright alignjustify | link image | code | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight |',
                  lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                  fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
                  font_formats:
                    'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                  image_description: false,
                  image_title: false,
                  content_style:
                    'img {max-width: 100%; max-height: 100%}, @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
                  image_dimensions: false,
                  file_picker_types: 'image',
                  images_upload_handler: imagesUploadHandlerFooter,
                  file_picker_callback: function (cb, value, meta) {
                    uploadImgTinyMce(cb);
                  },
                }"
                v-if="panelLeft === 'col-8'"
                v-model="emailTemplateCustom.htmlBodyEs"
              />

              <!-- rodapé do email -->
              <div class="row mb-2">
                <div class="col-12">
                  <input
                    type="text"
                    class="form-control input-panel"
                    :value="`Rodapé`"
                    disabled
                  />

                  <div class="row custom-switch" style="padding-left: 35px">
                    <div class="col-12">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="footer-custom"
                        v-model="
                          action.email.template.emailTemplateCustom.enableFooter
                        "
                      />
                      <label class="custom-control-label" for="footer-custom">{{
                        $t('newAction.stepOne.labels.able')
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <wysiwyg
                api-key="no-api-key"
                license_key="gpl2"
                tinymceScriptSrc="https://tinymce5.s3.amazonaws.com/tinymce/tinymce.min.js"
                :init="{
                  selector: 'wysiwyg',
                  menubar: false,
                  statusbar: false,
                  language: this.$t('newAction.stepOne.editorLanguage'),
                  plugins: 'link image lists hr emoticons',
                  toolbar:
                    'bold italic underline | alignleft aligncenter alignright alignjustify | link image | code | forecolor backcolor | bullist numlist | fontselect fontsizeselect formatselect | emoticons | hr | lineheight |',
                  lineheight_formats: '1 1.1 1.2 1.3 1.4 1.5 2',
                  fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt',
                  font_formats:
                    'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Lato=Lato; Roboto=Roboto, sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
                  image_description: false,
                  image_title: false,
                  content_style:
                    'img {max-width: 100%; max-height: 100%}, @import url(https://fonts.googleapis.com/css2?family=Roboto, sans-serif&display=swap);',
                  image_dimensions: false,
                  file_picker_types: 'image',
                  images_upload_handler: imagesUploadHandlerFooter,
                  file_picker_callback: function (cb, value, meta) {
                    uploadImgTinyMce(cb);
                  },
                }"
                v-if="panelLeft === 'col-8'"
                v-model="emailTemplateCustom.customHtmlFooterEs"
              />
            </div>
          </transition>
        </div>
      </template>
    </div>
    <div v-else class="text-center">
      <b-spinner
        variant="success"
        type="grow"
        label="Spinning"
        class="bg-primary"
      ></b-spinner>
    </div>
  </div>
</template>

<script>
import CountryFlag from 'vue-country-flag';
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import methodology from '../methodology';
import EventBus from '../../../../eventBus';
import modalTestSurveyEmailCustom from '../../../molecules/modal-test-survey-email';

export default {
  name: 'TemplateEmailCustom',

  components: {
    CountryFlag,
    methodology,
    modalTestSurveyEmailCustom,
  },

  data: () => ({
    loading: true,
    wysiwygOptions: {
      hideModules: {
        table: true,
        separator: true,
        code: true,
        removeFormat: false,
      },
      image: {
        uploadURL: null,
        dropzoneOptions: {
          headers: {},
        },
      },
    },
    logo: null,
    apiRoot: null,
    preview: false,
    userAuth: null,
    panelLeft: 'col-11',
    panelRight: 'col-1',
    panelOptions: false,
    noEditor: true,
    closingMessageType: 'default',
    promotersText: null,
    passivesText: null,
    detractorsText: null,
    countryName: 'Português',
    country: 'br',
    template: {
      html: '',
      enableTemplatePt: false,
      htmlEs: '',
      enableTemplateEs: false,
      htmlEn: '',
      enableTemplateEn: false,
    },
    showReturn: false,
    fileLogoHeader: null,
    emailTemplateCustom: {
      headerLogo: null,
      htmlBodyPt: '',
      htmlBodyEn: '',
      htmlBodyEs: '',
      customHtmlFooterPt: '',
      customHtmlFooterEn: '',
      customHtmlFooterEs: '',
      enableTemplatePt: false,
      enableTemplateEs: false,
      enableTemplateEn: false,
    },
  }),

  computed: {
    ...mapFields('actions', ['action', 'closingMessage']),
    ...mapState('companies', ['company']),
    ...mapState('templates', ['list', 'templateSelected']),
  },

  watch: {
    'emailTemplateCustom.htmlBodyPt':
      function watchEmailTemplateCustoHtmlBodyPt(html) {
        this.action.email.template.emailTemplateCustom.htmlBodyPt = html;
      },

    'emailTemplateCustom.customHtmlFooterPt':
      function watchEmailTemplateCustomHtmlFooterPt(html) {
        this.action.email.template.emailTemplateCustom.customHtmlFooterPt =
          html;
      },

    'emailTemplateCustom.htmlBodyEn':
      function watchEmailTemplateCustoHtmlBodyEn(html) {
        this.action.email.template.emailTemplateCustom.htmlBodyEn = html;
      },

    'emailTemplateCustom.customHtmlFooterEn':
      function watchEmailTemplateCustomHtmlFooterEn(html) {
        this.action.email.template.emailTemplateCustom.customHtmlFooterEn =
          html;
      },

    'emailTemplateCustom.htmlBodyEs':
      function watchEmailTemplateCustoHtmlBodyEs(html) {
        this.action.email.template.emailTemplateCustom.htmlBodyEs = html;
      },

    'emailTemplateCustom.customHtmlFooterEs':
      function watchEmailTemplateCustomHtmlFooterEs(html) {
        this.action.email.template.emailTemplateCustom.customHtmlFooterEs =
          html;
      },

    'emailTemplateCustom.headerLogo': function watchHeaderLogo(url) {
      this.action.email.template.emailTemplateCustom.headerLogo = url;
    },

    '$i18n.locale': function watchLocale() {
      this.changeLabels();
    },
  },

  methods: {
    selectUploadFile(files) {
      const blobUrl = URL.createObjectURL(files[0]);
      this.emailTemplateCustom.headerLogo = blobUrl;
      this.logo = blobUrl;
    },

    returnPanel() {
      this.panelLeft = 'col-11';
      this.panelRight = 'col-1';
      this.panelOptions = false;
      this.noEditor = true;
      this.showReturn = false;
      this.showPen = true;
      EventBus.$emit('returnPosition', this.comeBackPanel);
      document.getElementById('config-template').style.backgroundColor = '#fff';
    },

    removeTemplate(language) {
      if (language === 'pt') {
        this.emailTemplateCustom.enableTemplatePt = false;
        this.action.email.template.emailTemplateCustom.enableTemplatePt = false;
      } else if (language === 'en') {
        this.emailTemplateCustom.enableTemplateEn = false;
        this.action.email.template.emailTemplateCustom.enableTemplateEn = false;
      } else {
        this.emailTemplateCustom.enableTemplateEs = false;
        this.action.email.template.emailTemplateCustom.enableTemplateEs = false;
      }
    },

    saveTemplateTranslation(country) {
      if (country === 'Português') {
        this.emailTemplateCustom.enableTemplatePt = true;
        this.action.email.template.emailTemplateCustom.enableTemplatePt = true;
      }
      if (country === 'English') {
        this.emailTemplateCustom.enableTemplateEn = true;
        this.action.email.template.emailTemplateCustom.enableTemplateEn = true;
      }
      if (country === 'Español') {
        this.emailTemplateCustom.enableTemplateEs = true;
        this.action.email.template.emailTemplateCustom.enableTemplateEs = true;
      }
    },

    selectCountry(country) {
      if (country === 'Português') {
        this.countryName = country;
        this.country = 'br';
      } else if (country === 'English') {
        this.countryName = country;
        this.country = 'us';
      } else {
        this.countryName = country;
        this.country = 'es';
      }

      return this.country;
    },

    imagesUploadHandlerFooter(blobInfo, success, failure) {
      const xhr = new XMLHttpRequest();
      xhr.withCredentials = false;
      xhr.open('POST', `${process.env.API_ROOT}/image-footer/action`);
      xhr.setRequestHeader('x-access-token', this.userAuth.token);
      xhr.onload = function analise() {
        if (xhr.status !== 200) {
          failure(`HTTP Error: ${xhr.status}`);
          return;
        }
        const json = JSON.parse(xhr.responseText);

        if (!json || typeof json !== 'string') {
          failure(`Invalid JSON: ${xhr.responseText}`);
          return;
        }
        success(json);
      };

      const formData = new FormData();
      formData.append('file', blobInfo.blob(), blobInfo.filename());
      xhr.send(formData);
    },

    uploadImgTinyMce(cb) {
      const $input = document.createElement('input');
      $input.setAttribute('type', 'file');
      $input.setAttribute('accept', 'image/*');
      this.uploadedImageURL = this.image;
      $input.onchange = function onChangeImg() {
        const file = this.files[0];
        const reader = new FileReader();
        reader.onload = function readerImg() {
          const id = `blobid${new Date().getTime()}`;
          const blobCache = window.tinymce.activeEditor.editorUpload.blobCache;
          const base64 = reader.result.split(',')[1];
          const blobInfo = blobCache.create(id, file, base64);
          blobCache.add(blobInfo);
          cb(blobInfo.blobUri(), { title: file.name });
        };
        reader.readAsDataURL(file);
      };
      $input.click();
    },

    expandPanel() {
      this.panelLeft = 'col-8';
      this.panelRight = 'col-4';
      this.larguePanel = 'col-12';
      this.panelOptions = true;
      this.noEditor = false;
      this.showReturn = true;
      this.showPen = false;
      EventBus.$emit('editorPosition', this.larguePanel);
      document.getElementById('config-template').style.backgroundColor = '#fff';
    },

    changeLabels() {
      if (this.action.type.includes('0-10')) {
        this.promotersText = this.$t(
          'newAction.closingMessageGrades.zeroToTen.promoters',
        );
        this.passivesText = this.$t(
          'newAction.closingMessageGrades.zeroToTen.passives',
        );
        this.detractorsText = this.$t(
          'newAction.closingMessageGrades.zeroToTen.detractors',
        );
      } else if (this.action.type === 'like-dislike') {
        this.promotersText = this.$t(
          'newAction.closingMessageGrades.zeroAndOne.promoters',
        );
        this.passivesText = '';
        this.detractorsText = this.$t(
          'newAction.closingMessageGrades.zeroAndOne.detractors',
        );
      } else {
        this.promotersText = this.$t(
          'newAction.closingMessageGrades.oneToFive.promoters',
        );
        this.passivesText = this.$t(
          'newAction.closingMessageGrades.oneToFive.passives',
        );
        this.detractorsText = this.$t(
          'newAction.closingMessageGrades.oneToFive.detractors',
        );
      }
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.wysiwygOptions.image.uploadURL = `${process.env.API_ROOT}/action/image-closing-message/${this.userAuth.companyId}`;

    this.wysiwygOptions.image.dropzoneOptions.headers = {
      'x-access-token': this.userAuth.token,
    };
  },

  async mounted() {
    this.loading = true;
    this.apiRoot = process.env.API_ROOT;

    this.changeLabels();

    if (!this.$store.state.actions.action.email.template.emailTemplateCustom) {
      this.loading = true;
      this.$store.state.actions.action.email.template.emailTemplateCustom = {
        enableHeaderLogo: false,
        headerLogo: null,
        enableBody: false,
        htmlBodyPt: '',
        htmlBodyEn: '',
        htmlBodyEs: '',
        enableFooter: false,
        customHtmlFooterPt: '',
        customHtmlFooterEn: '',
        customHtmlFooterEs: '',
        questionPt: '',
        questionEs: '',
        questionEn: '',
        enableTemplatePt: false,
        enableTemplateEs: false,
        enableTemplateEn: false,
      };
      this.loading = false;
    }

    const logoUrl = process.env.INDECX_FILES_BUCKET;
    if (this.action.email.template.emailTemplateCustom.headerLogo) {
      this.logo = `${logoUrl}/${this.action.email.template.emailTemplateCustom.headerLogo}`;
    } else {
      this.logo = `${logoUrl}/${this.action.logo}`;
    }

    this.emailTemplateCustom.headerLogo = this.action.email.template
      .emailTemplateCustom.headerLogo
      ? this.action.email.template.emailTemplateCustom.headerLogo
      : this.logo;

    this.emailTemplateCustom.htmlBodyPt = this.action.email.template
      .emailTemplateCustom.htmlBodyPt
      ? this.action.email.template.emailTemplateCustom.htmlBodyPt
      : this.action.email.template.myHTML;
    this.emailTemplateCustom.customHtmlFooterPt = this.action.email.template
      .emailTemplateCustom.customHtmlFooterPt
      ? this.action.email.template.emailTemplateCustom.customHtmlFooterPt
      : '<div>Adicione uma mensagem no rodapé</div>';
    this.emailTemplateCustom.enableTemplatePt = this.action.email.template
      .emailTemplateCustom.enableTemplatePt
      ? this.action.email.template.emailTemplateCustom.enableTemplatePt
      : false;

    this.emailTemplateCustom.htmlBodyEn = this.action.email.template
      .emailTemplateCustom.htmlBodyEn
      ? this.action.email.template.emailTemplateCustom.htmlBodyEn
      : this.action.email.template.myHTMLEn;
    this.emailTemplateCustom.customHtmlFooterEn = this.action.email.template
      .emailTemplateCustom.customHtmlFooterEn
      ? this.action.email.template.emailTemplateCustom.customHtmlFooterEn
      : '<div>Add a message in the footer</div>';
    this.emailTemplateCustom.enableTemplateEn = this.action.email.template
      .emailTemplateCustom.enableTemplateEn
      ? this.action.email.template.emailTemplateCustom.enableTemplateEn
      : false;

    this.emailTemplateCustom.htmlBodyEs = this.action.email.template
      .emailTemplateCustom.htmlBodyEs
      ? this.action.email.template.emailTemplateCustom.htmlBodyEs
      : this.action.email.template.myHTMLEs;
    this.emailTemplateCustom.customHtmlFooterEs = this.action.email.template
      .emailTemplateCustom.customHtmlFooterEs
      ? this.action.email.template.emailTemplateCustom.customHtmlFooterEs
      : '<div>Agregar un mensaje en el pie de página</div>';
    this.emailTemplateCustom.enableTemplateEs = this.action.email.template
      .emailTemplateCustom.enableTemplateEs
      ? this.action.email.template.emailTemplateCustom.enableTemplateEs
      : false;

    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.tag {
  background: $primary;
  padding: 4px 8px;
  color: $white;
  border-radius: 8px;
  margin-right: 8px;
  width: 200px;
  margin-top: 5px;

  .remove {
    cursor: pointer;
  }
}

.row {
  padding: 0 14px;
}

.panel-template {
  transition: all 0.2s linear;

  padding: 0 30px 0 0;
  > div {
    margin-top: 10px;
    &:first-of-type {
      margin-top: 0;
    }
  }

  .template-header {
    border: 1px dashed $gray;
    padding: 10px;
    text-align: center;

    img {
      height: 70px;
    }
  }
  .template-body {
    border: 1px dashed $gray;
    padding: 10px;
  }

  .template-question {
    border: 1px dashed $gray;
    padding: 10px;
  }
}

.config-template {
  transition: all 0.2s linear;
  padding-top: 17px;
  padding-left: 30px;
  margin-top: -17px;
  background-color: #fff;
  position: relative;
  min-height: 330px;
  .input-panel {
    background-color: transparent;
    padding: 0;
    border: none;
    font-size: 0.9em;
    margin-top: 10px;
    font-weight: bold;
    &:first-of-type {
      margin-top: 10px;
    }
  }
  .btn-actions {
    display: flex;
    flex-direction: column;
    width: 40px;
    position: absolute;
    left: -20px;
    .btn {
      margin-bottom: 5px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
    .preview {
      margin: 5px 0;
    }
  }

  .custom-control-label {
    font-size: 0.8em;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.btn-view {
  max-width: 40px;
}

@media (max-width: 1500px) {
  .config-template {
    position: absolute;
    top: 57px;
    right: 20px;
  }
}
</style>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.info-obs {
  font-size: 10px;
}

.no-editor img {
  max-width: 100%;
}

.no-editor {
  min-height: 300px;
}

.template-methodology {
  border: 1px dashed $gray;
  padding: 10px;
}

.template-footer {
  border: 1px dashed $gray;
  padding: 10px;
  text-align: center;
  img {
    width: 80px;
  }
  p {
    margin: 0;
    padding: 0;
    font-size: 0.9em;
    margin-top: 10px;
  }
}

.footer-content {
  border: 1px dashed $gray;
  padding: 10px;
  height: auto;
  overflow: hidden;
}

.template-body {
  border: 1px dashed $gray;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/action-templates/template-email-custom/index.vue